var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthenticated)?_c('BtnGradient',{staticClass:"btn-enter",on:{"click":_vm.goToCabinet}},[_vm._v(" Cabinet ")]):_c('BtnGradient',{staticClass:"btn-enter",on:{"click":_vm.goToAuth}},[_vm._v("Sign In / Sign Up")])}
var staticRenderFns = []

export { render, staticRenderFns }